import * as React from 'react';
import { BaseRouteProps } from '../../../interfaces';
import { PVAPage } from '../../../components';
import { ScoreCardGroupDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { ScoreCardGroupForm } from './ScoreCardGroupForm';

export class ScoreCardGroupCreate extends React.Component<BaseRouteProps<{scoreCardId: number}>> {
    private scoreCardGroupDataService = new ScoreCardGroupDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{scoreCardId: number}>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/scorecardgroup`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Score Card Group
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <ScoreCardGroupForm submit={(e: any) => this.save(e)} defaultValues={{}} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        values.ScoreCardID = this.props.match.params.scoreCardId;
        this.scoreCardGroupDataService.create(values).then((success) => {
            this.props.history.push(`/scorecards/${values.ScoreCardID}/groups/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroup/ScoreCardGroupCreate.tsx